export default "__VITE_PUBLIC_ASSET__ee913fc6__"